import { ThemeCss, ThemeVars } from './WhiteLabelOverride';
import { WhiteLabelTheme } from '../../store/WhiteLabelProvider';

export const mapButtonStyles = (
  theme: WhiteLabelTheme,
  disabled: boolean,
  variant: 'primary' | 'secondary' = 'primary',
): ThemeCss => {
  const vars: ThemeVars = {};
  let overrides = '';

  const isSecondary = variant === 'secondary';

  if (theme.primary_color && !disabled) {
    // overwrites css variable for orion outlines
    vars['--color-primary-40'] = theme.primary_color;
    vars['--color-primary-10'] = theme.primary_color;

    // replaces orion buttons hardcoded gradient background
    overrides += `
      .white-label-scope.button.${variant}:not(.disabled) button {
        background: linear-gradient(
          180deg,
          ${theme.primary_color}${isSecondary ? '10' : ''} 0%,
          color-mix(in srgb, ${theme.primary_color} 90%, white) 100%
        );
      }
      .white-label-scope.button.${variant}:not(.disabled) button:hover {
        background: linear-gradient(
          180deg,
          color-mix(in srgb, ${theme.primary_color}${isSecondary ? '10' : ''} 95%, black) 0%,
          color-mix(in srgb, ${theme.primary_color} 90%, black) 100%
        );
      }
      .white-label-scope.button.${variant}:not(.disabled) button:active {
        background: linear-gradient(
          180deg,
          color-mix(in srgb, ${theme.primary_color}${isSecondary ? '10' : ''} 95%, black) 0%,
          color-mix(in srgb, ${theme.primary_color} 90%, black) 100%
        );
      }
      .white-label-scope.button:not(.disabled) a {
        background: linear-gradient(
          180deg,
          ${theme.primary_color}${isSecondary ? '10' : ''} 0%,
          color-mix(in srgb, ${theme.primary_color} 90%, white) 100%
        );
      }
      .white-label-scope.button:not(.disabled) a:hover {
        background: linear-gradient(
          180deg,
          color-mix(in srgb, ${theme.primary_color}${isSecondary ? '10' : ''} 95%, black) 0%,
          color-mix(in srgb, ${theme.primary_color} 90%, black) 100%
        );
      }
    `;
  }
  if (theme.text_color) {
    // Orion button text value
    vars['--color-structure-100'] = theme.text_color;
  }

  return { vars, overrides };
};

export const mapBackgroundStyles = (theme: WhiteLabelTheme): ThemeCss => {
  const vars: ThemeVars = {};
  let overrides = '';

  if (theme.secondary_color) {
    // Background shadow variable colour
    vars['--color-secondary-95'] = theme.secondary_color;
    vars['--color-secondary-97'] = theme.secondary_color;

    // tailwind override for the above
    overrides += `
      .white-label-scope.background .bg-secondary-95 {
        background: ${theme.secondary_color}
      }
    `;
  }

  return { vars, overrides };
};

export const mapProgressStyles = (theme: WhiteLabelTheme): ThemeCss => {
  const vars: ThemeVars = {};
  const overrides = '';

  if (theme.primary_color) {
    // Override the color variable for the progress bar indicator
    vars['--color-primary-10'] = theme.primary_color;
  }

  return { vars, overrides };
};
